(function() {
	'use strict';
	angular.module('app.core')
		.directive('leanStringFilter', leanStringFilter);
	
	leanStringFilter.$inject = ['$translate'];
	function leanStringFilter($translate) {
		var html = '<div class="string-menu" ng-show="$parent.filterFunctions.getViewValues().visibleMenu == ' + "'" + '{{filterId}}' + "'" + '" ng-click="$event.stopPropagation();">' +
						'<form name="stringForm" novalidate>' +
							'<div class="string-header">' +
								'<div class="string-title"><span translate> {{filterName}}</span></div>' +
							'</div>' +
							'<div class="string-body">' +
								'<div class="filter-dropdown form-group" ng-click="$event.stopPropagation();">' +
									'<span class="string-span" translate>Partial Match</span>' +
									'<input name="value" type="text" class="form-control" ng-required="true" ng-model="filterValue" placeholder="' + $translate.instant('Enter value') + '..." ng-disabled="readOnly">' +
								'</div>' +
							'</div>' +
							'<div class="string-footer" ng-show="!readOnly">' +
								'<button type="button" class="button flat colored innerButton" ng-click="$parent.filterFunctions.cancelSelection()">' +
									'<span translate>Cancel</span>' +
								'</button>' +
								'<button type="submit" class="button flat colored innerButton" data-testid="reportFilter-' + '{{filterId}}' + '-apply-btn" ng-disabled="$parent.filterFunctions.isReadOnly()" ng-click="$parent.filterFunctions.applySelection($event, filterId)">' +
									'<span translate>Apply</span>' +
								'</button>' +
							'</div>' +
						'</form>' +
					'</div>';
		return {
			restrict:'EA',
			template: html,
			replace:true,
			transclude: true,
			scope: {filterName: '@',
											filterValue: '=',
											filterLabel: '@',
											filterId: '@'},
			link: function(scope, element, attrs) {
				scope.readOnly = scope.$parent.filterFunctions.isReadOnly();
				scope.getItemLabel = function(item) {
					return scope.$eval(scope.filterLabel, item);
				};
			}
		};
	}
})();
